import Constant from '@/const'
import Store from '@/store/index.js'
export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async getBase64({ commit, dispatch }, data) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        params: data,
        url: Constant.API_URL.HISTORY + '/photos/base64',
        error: { message: '車両画像の取得でエラーが発生しました。' },
      }
      return dispatch('http/post', { ...request }, { root: true })
        .then((res) => {
          return res
        })
        .catch((err) => {
          throw new Error(err.message)
        })
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/photo.js